import React from 'react';

/** Presentational */
import ProjectList from '../components/Apps/BoeingELA/projectList/ProjectList';

const BoeingELA = () => {
  return (
    <div>
      <ProjectList />
    </div>
  );
};

export default BoeingELA;
